<template>
  <div class="ProgressStepper">
    <div
      v-for="(step) in steps"
      :key="step.id"
      :class="{
        'is-active': step.isActive,
        'is-complete' : step.isComplete,
        'can-change-steps': canChangeSteps,
      }"
      class="ProgressStepper-step"
      @click="changeStep(step.id)"
    />
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => [],
      required: true,
    },
    canChangeSteps: {
      type: Boolean,
      default: false,
    },
  },

  computed: {},

  methods: {
    changeStep(stepId) {
      if (!this.canChangeSteps) return;

      this.$emit('progress-stepper:change-step', stepId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/abstracts.scss";
.ProgressStepper {
  display: flex;
  justify-content: center;
  text-align: center;

  .ProgressStepper-step {
    background: color('grey', 'light');
    height: 6px;
    width: 30px;
    margin: spacing(xs);
    cursor: default;

    &.can-change-steps {
      cursor: pointer;
    }

    &.is-complete {
      background: color($success-color);
    }

    &.is-active {
      background: color($primary-color);
    }

  }
}
</style>
